<template>
  <div class="container" data-aos="fade-right">
    <p class="code-status">404</p>
    <p class="code-text article-1">
      Ooops. This page doesn’t exist or don’t work anymore
    </p>
    <p class="code-text article-2">
      Don’t worry, you can try later. Keep shopping.
    </p>
    <router-link :to="{name: 'Home'}"><base-button>Home</base-button></router-link>
  </div>
</template>



<style scoped>
.container {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 850px;
}

.code-status {
  color: #000;
  font-family: "Glusp";
  font-size: 19rem;
  font-weight: 700;
}

.code-text {
  color: #000;
  font-family: "Mabry Pro";
}

.article-1 {
  font-size: 3rem;
  font-weight: 500;
}

.article-2 {
  font-size: 2.8rem;
  font-weight: 300;
  margin-bottom: 30px;
}

a {
  color: #fff;
  text-decoration: none;
}

@media screen and (min-width: 240px) and (max-width: 480px) {
  .container {
    height: 400px;
  }
  .code-status {
    font-size: 5rem;
  }
  .article-1 {
    font-size: 2rem;
    text-align: center;
  }
  .article-2 {
    font-size: 1.8rem;
    text-align: center;
  }
 
}

@media screen and (min-width: 481px) and (max-width: 768px) {
  .code-status {
    font-size: 15rem;
  }
  .article-1 {
    font-size: 2.5rem;
    text-align: center;
  }
  .article-2 {
    font-size: 2.3rem;
    text-align: center;
  }
}

</style>